<template>
  <div class="flex-col org-main">
    <div class="div-top">
      <i class="iconfont iconbuilding-outline"
        style="font-size: 0.875rem; color: #c52a1a"></i>
      <div class="org-name">{{ $t("orgName") }}</div>
      <div id="his-org-filter"
        class="filter"
        v-if="showFilter"
        @click="showSearch">
        <span> {{ $t("common.filter") }} </span>
        <i class="iconfont iconfilter-outline"></i>
      </div>
      <van-popup v-model="showSearchPanel"
        position="right"
        :style="{ height: '100%', width: '80%' }">
        <search-panel :type="searchPanelType"
          @search="searchByPanel"
          ref="orgSelect"></search-panel>
      </van-popup>
    </div>

    <div class="cont-list">
      <van-list v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad">
        <org-item v-for="item in list"
          v-bind:key="item.historyId"
          :data="item"
          :show-chk="isEdit"
          @cancel="cancelMark"
          :disable-swipe="disableSwipe" />
      </van-list>
    </div>
  </div>
</template>

<script>
import SearchPanel from "@components/common/SearchPanel";
import OrgItem from "@components/content/org/OrgItem";
import common from "@common/common";
import webService from "@network/webService";
export default {
  name: "",
  data () {
    return {
      disableSwipe: true,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      currentPage: 0,
      showSearchPanel: false,
      searchPanelType: common.searchTypeEnum.org,
      oldSearchModel: {
        Search: "",
        SearchType: common.relationshipSearchTypeEnum.PEOrganization,
        InvestmentPreferenceIds: [],
        IndustryIds: [],
        InvestmentTypeIds: [],
        OrgStage: [],
        OrgIndustry: [],
      },
      showFilter: false,
    };
  },
  props: {
    pageType: {
      type: Number,
      default: 0,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    OrgItem,
    SearchPanel,
  },
  created () {
    // console.log("pageType", this.pageType);
    this.showFilter = false;
  },
  mounted () {
    this.disableSwipe = true;
  },
  // activated() {
  //     this.currentPage = 0;
  //     this.list = [];
  //     this.onLoad();
  // },
  methods: {
    reset () {
      console.log("reset");
      this.list = [];
      this.loading = false;
      this.finished = false;
    },
    onRefresh () {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.currentPage = 0;
      this.list = [];
      this.onLoad();
    },
    onLoad () {
      console.log(this.currentPage);
      if (this.currentPage == 0) {
        this.list = [];
      }
      console.log(this.list);
      this.requestPageData();
    },
    searchByPanel (searchParams) {
      if (searchParams.hasFilter) {
        document.getElementById('his-org-filter').classList.add('has-filter');
      } else {
        document.getElementById('his-org-filter').classList.remove('has-filter');
      }
      this.currentPage = 0;
      this.list = [];
      if (this.searchPanelType == common.searchTypeEnum.org) {
        this.oldSearchModel.SearchType =
          common.relationshipSearchTypeEnum.PEOrganization;
        this.oldSearchModel.InvestmentPreferenceIds =
          searchParams.InvestmentPreferenceIds;
        this.oldSearchModel.IndustryIds = searchParams.IndustryIds;
        this.oldSearchModel.InvestmentTypeIds =
          searchParams.InvestmentTypeIds;
        this.oldSearchModel.OrgStage = searchParams.OrgStage;
        this.oldSearchModel.OrgIndustry = searchParams.OrgIndustry;
      }
      this.showSearchPanel = false;
      console.log(searchParams);
      //web 数据请求
      this.requestPageData();
    },
    getData (searchModel) {
      // debugger;
      this.currentPage = 0;
      this.list = [];
      if (!searchModel) {
        searchModel = {
          PageSize: 100,
          Page: 0,
          SearchType:
            common.relationshipSearchTypeEnum.PEOrganization,
        };
      } else if (this.searchPanelType == common.searchTypeEnum.org) {
        this.oldSearchModel = searchModel;
      }
      //web 数据请求
      this.requestPageData();
    },
    requestPageData () {
      let searchModel = {
        PageSize: 20,
        Page: this.currentPage,
        SearchType: this.oldSearchModel.SearchType,
        Search: this.oldSearchModel.Search,
        InvestmentPreferenceIds:
          this.oldSearchModel.InvestmentPreferenceIds,
        IndustryIds: this.oldSearchModel.IndustryIds,
        InvestmentTypeIds: this.oldSearchModel.InvestmentTypeIds,
        FavoriteType: common.favoriteTypeEnum.Organization,
        OrgStage: this.oldSearchModel.OrgStage,
        OrgIndustry: this.oldSearchModel.OrgIndustry,
        OrderType: 3
      };
      //console.log(searchModel);
      webService.searchOrgHistoryList(searchModel).then((res) => {
        common.procssData(this, res.data);
      });
    },
    showSearch () {
      this.showSearchPanel = true;
      if (this.$refs.orgSelect) {
        this.$refs.orgSelect.initSelectItem();
      }
    },
    selectAll () {
      this.list.forEach((element) => {
        element.checked = true;
      });
    },
    cancelSelected () {
      this.list.forEach((element) => {
        element.checked = false;
      });
    },
    deleteItem () {
      common.batchDeleteMarked(this);
    },
    cancelMark (id) {
      common.cancelMark(this, id);
    },
    changeSearchValue (value) {
      this.oldSearchModel.Search = value;
    },
  },
};
</script>

<style lang='less' scoped>
.org-main {
  border-top: 1px solid #dedede;
  height: 100%;
}
.div-top {
  display: flex;
  padding: 0.375rem 0.625rem;
  align-items: center;
  height: 2.875rem;
  .org-name {
    flex: 2;
    font-size: 14px;
    font-weight: bolder;
    color: #464646;
    margin-left: 0.375rem;
  }
  .filter {
    text-align: right;
    flex: 1;
    span {
      font-size: 0.875rem;
    }
    img {
      width: 1.25rem;
      vertical-align: middle;
    }
  }
}
.cont-list {
  overflow: auto;
  // flex: 1;
  height: 100%;
}

/deep/ .van-tabs__line {
  background-color: #c52a1a;
}
// // /deep/ .van-list {
// //   height: 100%;
// // }
</style>


// WEBPACK FOOTER //
// src/views/history/HisOrgList.vue